import { createAction, handleActions } from 'redux-actions'

const setProjectSubcontractors = createAction('MODALS/TIMESHEET/SET_PROJECT_SUBCONTRACTORS')
const clearProjectSubcontractors = createAction('MODALS/TIMESHEET/CLEAR_PROJECT_SUBCONTRACTORS')

const defaultState = []

const reducer = handleActions(
  {
    [setProjectSubcontractors]: (state, action) => action.payload,
    [clearProjectSubcontractors]: () => defaultState,
  },
  defaultState,
)

export { setProjectSubcontractors, clearProjectSubcontractors, reducer }
